export const MINIMUM_CAPTION_GAP = 0.07